import _ from "lodash";
import sha256 from "js-sha256";
import { getNotifyToken } from "@/http/api/auth";
import mqtt from "mqtt/dist/mqtt";
import indexedDB from "@/indexedDB/dbUtil.js";
import Guid from "@/utils/guid";
import { store } from "@/store";
import dayjs from "dayjs";

let { openDB, addData, getDataByIndex, updateDB, cursorDelete, deleteDB } = indexedDB();

const appId = "ex2ka0";
const host = "wss://ex2ka0.cn1.mqtt.chat";
const notifyType = ["N000", "N001", "N002", "N003", "N004", "N005", "N006"];
const noNotifyType = ["C000", "C001", "C002", "C003"];
const prefix = process.env.VUE_APP_SAFE_CLIENT_ID_PREFIX;

const authModule = {
  namespaced: true,
  state: {
    deviceId: localStorage.getItem("deviceId") || null,

    livingDB: null,
    client: null,
    notifyToken: localStorage.getItem("notifyToken") || null,
    unread: localStorage.getItem("unread") || null
  },
  mutations: {
    setNotifyToken(state, data) {
      state.notifyToken = data;
      localStorage.setItem("notifyToken", data);
    },

    setDeviceId(state, data) {
      state.deviceId = data;
      localStorage.setItem("deviceId", data);
    },
    setUnread(state, val) {
      state.unread = val;
      localStorage.setItem("unread", val);
    },
    clear(state) {
      if (state.client) {
        state.client.end();
        state.client = null;
        localStorage.removeItem("client");
      }
    }
  },
  getters: {},
  actions: {
    //获取环信token
    async getNoticeToken({ commit }) {
      const { data } = await getNotifyToken();
      if (!data) {
        return false;
      }
      commit("setNotifyToken", data);
      return true;
    },
    //环信连接
    async subscribe({ state, commit, dispatch }, userInfo) {
      let { isSuperMan, userAccountId } = userInfo;
      if (isSuperMan) return;
      try {
        const result = await dispatch("getNoticeToken");
        if (!result) {
          console.log("消息服务连接失败");
          return;
        }
        if (!state.deviceId) {
          await commit("setDeviceId", Guid());
        }
        let userID = store.state.auth.userData.userAccountId.slice(24, 32);

        state.client = mqtt.connect(host, {
          keepalive: 60,
          protocolVersion: 4,
          clientId: `${prefix}_${userID}_${state.deviceId}@${appId}`,
          clean: false,
          password: state.notifyToken,
          username: "app",
          reconnectPeriod: 100,
          connectTimeout: 30 * 1000,
          resubscribe: true,
          appid: appId
        });
        state.client.on("connect", () => {
          state.client.subscribe(`notify/guansafety/${userAccountId}`, {
            qos: 1
          });
          dispatch("getUnReadNotify");
        });

        // let payload =
        // {
        //   content: {
        //     msgType: "video",

        //     title: "消息标题",
        //     body: "消息描述",

        //     applicationIcon: "https://vrgv-default0.obs.cn-east-3.myhuaweicloud.com:443/20223_1648102902486_20221_1643475450698_未标题-1_31.png",
        //     applicationName: "MSDS",

        //     appLink: ["buttonText", "buttonUrl"],
        //     webLink: ["webLinkbuttonText", "http://localhost:3000/#/organization"],

        //     video: "https://vrgv-default0.obs.cn-east-3.myhuaweicloud.com:443/20224_1651058915889_animalParty.mp4",
        //   },
        //   dateTime: "2022-05-26 08:52:41",
        //   type: "N000"
        // }
        // '{"content":{"link":["立即审核","/pages/dashboard/setting/member/audit"],"title":"新成员申请加入企业","body":"【糖醋里脊第四次测试】zhangfeng1已申请加入您的企业请立即处理。"},"dateTime":"2002-01-07 08:39:03","link":["立即审核","/pages/dashboard/setting/member/audit"],"type":"C001"}';
        // console.log("JSON.parse(payload)", JSON.parse(payload));
        // dispatch("addNotify", JSON.parse(payload));
        // dispatch("addNotify", payload);
        dispatch("getN01NotifyList");
        dispatch("deleteOtherMessage");

        state.client.on("message", async (topic, payload) => {
          console.log(`${topic}: ${payload}`);
          if (payload != "") {
            if (notifyType.indexOf(JSON.parse(payload).type) > -1) {
              dispatch("addNotify", JSON.parse(payload));
              state.client.publish(topic, "");
              dispatch("getUnReadNotify");
            } else {
              dispatch("otherMessageOperation", JSON.parse(payload));
            }
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    //打开数据库
    async openDataset({ state }) {
      let data = {
        dbName: "messageDB",
        dbVersion: 1
      };
      await openDB(data.dbName, data.dbVersion).then((db) => {
        state.livingDB = db;
      });
    },
    //添加notify
    async addNotify({ state }, data) {
      let params = {
        ...data,
        state: 1,
        notifyId: Guid(),
        userId: store.state.auth.userData.userAccountId || null
      };
      if (data.content && data.content.body && data.content.title && data.dateTime && data.type) {
        addData(state.livingDB, "MASSAGE_TABLE", params);
      } else {
        console.log("↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓消息体格式不正确↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓");
        console.log("Message", data);
        console.log("↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑消息体格式不正确↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑");
      }
    },

    //根据userID查询当前用户的所有消息
    async getAllNotifyList({ commit, state, dispatch }) {
      await dispatch("openDataset");
      const data = await getDataByIndex(state.livingDB, "MASSAGE_TABLE", "userId", store.state.auth.userData.userAccountId || null);
      return data;
    },

    //根据userID查询当前用户的所有消息并读取未读消息的个数
    async getUnReadNotify({ commit, state, dispatch }) {
      await dispatch("openDataset");
      const data = await getDataByIndex(state.livingDB, "MASSAGE_TABLE", "userId", store.state.auth.userData.userAccountId || null);
      let number = 0;
      data.forEach((item) => {
        if (item.state != "0" && notifyType.indexOf(item.type) > -1) {
          number++;
        }
      });
      if (number == 0) {
        commit("setUnread", null);
      } else {
        commit("setUnread", number);
      }
    },

    //更新未读数据
    async getUpdateNotify({ commit, state, dispatch }, value) {
      await dispatch("openDataset");
      const data = await updateDB(state.livingDB, "MASSAGE_TABLE", value);
      dispatch("getUnReadNotify");
      return data;
    },

    //根据userID查询当前用户的欢迎通知
    async getN01NotifyList({ commit, state, dispatch }) {
      await dispatch("openDataset");
      const data = await getDataByIndex(state.livingDB, "MASSAGE_TABLE", "userId", store.state.auth.userData.userAccountId || null);
      let N01 = [];
      data.forEach((item) => {
        if (item.type == "N001") {
          N01.push(item);
        }
      });
      let trueAdd = true;
      N01.forEach((item) => {
        if (item.content.title == "欢迎使用管管安全") {
          trueAdd = false;
        }
      });
      if (trueAdd) {
        let payload = {
          type: "N001",
          content: {
            title: "欢迎使用管管安全",
            body: "欢迎您使用管管安全，在使用过程中如果遇到问题，可拨打 400-669-1229 联系客服人员。"
          },
          dateTime: dayjs(dayjs().toString()).format("YYYY-MM-DD HH:mm:ss")
        };
        dispatch("addNotify", payload);
      } else {
        return;
      }
    },
    //删除其他消息
    async deleteOtherMessage({ state, dispatch }) {
      await dispatch("openDataset");
      noNotifyType.forEach((item) => {
        cursorDelete(state.livingDB, "MASSAGE_TABLE", "type", item);
      });

      let allUserMessage = await dispatch("getAllNotifyList");
      allUserMessage.forEach((item) => {
        if (item.content && item.content.body && item.content.title && item.dateTime && item.type) {
        } else {
          deleteDB(state.livingDB, "MASSAGE_TABLE", item.notifyId);
        }
      });
    },
    //其他消息操作
    otherMessageOperation({ state, dispatch }, data) {
      console.log("code", data.code);
      switch (data.code) {
        case "C000":
          store.dispatch("auth/refreshCompanyInfo");
          return;
        case "C001": //当企业主管理员审批成员完成时，及企业认证状态变更后，刷新企业列表
          store.dispatch("auth/getCompanyList");
          return;
        case "C002": //当企业主管理员发生获取/购买应用的操作后，刷新我的应用
          return;
        case "C003": //当企业权限发生变更，刷新权限
          store.dispatch("auth/getRoleList");
          return;
        case "C004": //当企业权限发生变更，刷新权限
          if (data.companyId === store.getters["auth/currentCompany"]["companyId"]) {
            store.commit("auth/adminAccountMessageAlert");
          } else {
            store.commit("auth/setAdminAccountAlert", {
              companyId: data.companyId,
              flag: true
            });
          }
          return;
        default:
          return;
      }
    }
  }
};

export default authModule;
